import SvgIcon from "./TrashIcon.svg?react";

export const TrashIcon = SvgIcon;
